import { HttpHeaders } from '@angular/common/http';

/**
 * The `Idempotency-Key` for POST report/order: one key per distinct order.
 *
 * A retry or a double click sends the same body and so gets the same key,
 * which the backend answers with the first order instead of placing another.
 * Any change to the order gets a new key, since the backend refuses a key
 * reused for a different order.
 */
export class OrderIdempotencyKey {
  private lastBody: string | null = null;
  private key = '';

  public headersFor(body: unknown): HttpHeaders {
    const serialized = JSON.stringify(body);
    if (serialized !== this.lastBody) {
      this.lastBody = serialized;
      this.key = newKey();
    }
    return new HttpHeaders({ 'Idempotency-Key': this.key });
  }
}

function newKey(): string {
  // crypto.randomUUID needs a secure context; local http dev is not one.
  return typeof crypto !== 'undefined' && 'randomUUID' in crypto
    ? crypto.randomUUID()
    : `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
}
